<template>
    <!-- <section>-->
    <v-container>    
        <div class="limiter-content pa-2 pa-lg-0">
            
            <v-row>
                <v-col>
                    <div class="font-weight-bold mt-10 title-page" tabindex="0">Análise de Ofício</div>
                </v-col>
            </v-row>
    
            <br />

            <div class="mt-4" v-if="dataset.loading">
                <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
            </div>

            <div v-html="dataset.description" tabindex="0"></div>          

            <br />

            <v-container v-if="user">
                <template v-if="dataset.dataList.amount && dataset.dataList.reason">
                  <v-card class="pa-4" elevation="3">
                    <v-card-title class="card-group-title">
                      Detalhes
                    </v-card-title>
              
                    <v-divider class="mb-3"></v-divider>
              
                    <v-card-text>
                      <p><strong>Valor:</strong> {{ dataset.dataList.amount | currency }}</p>
                      <p><strong>Motivo:</strong> <span v-html="dataset.dataList.reason"></span></p>
                    </v-card-text>
                  </v-card>
                </template>
              
                <v-alert v-else type="info" outlined>
                  Nenhuma informação disponível.
                </v-alert>
            </v-container>
              
            <!-- <v-container v-else>
                <v-alert type="warning" outlined>
                  Por favor, realize o seu login para ter acesso à Análise de Ofício.
                </v-alert>
            </v-container> -->

            <div class='mt-10' v-if='!user'>
                <h4>Por favor, realize o seu login para ter acesso à Análise de Ofício.</h4>
            </div>

            <!-- <v-row>
                <whatsButton/>
            </v-row>
            
            <v-row>
                <topButton/>
            </v-row> -->
        </div>
    </v-container>
    <!-- </section> -->
</template>
        
<script>
import 'moment/locale/pt-br';
import axios from 'axios';

import { eventHub } from "@/main";
//import topButton from '@/components/layout/GoToTopButton.vue';
//import whatsButton from '@/components/layout/WhatsAppButton.vue';

export default {
    // components: {
    //     topButton,
    //     whatsButton,
    // },
    
    data: () => ({
        user: null,
        dialogPopup: false,
        dataset: {
            documents: [],
            description: '',
            loading: false,
            dataList: {},
        }
    }),

    mounted: function () {
    },

    created() {
        if (this.$root.user) {
            this.user = this.$root.user;
            this.loadAnalysis();
            this.loadText();
        }

    },

    methods: {
        openRegister() {
            eventHub.$emit("DIALOG-REGISTER", true)
        },

        async loadText() {
            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                params: { keys: 'official-analysis-description' }
                });

                if (result.data.content && result.data.content.length > 0) {
                    this.dataset.description = result.data.content[0].value;
                } else {
                    this.dataset.description = ''; 
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async loadAnalysis() {

            this.dataset.loading = true;

            try {
                const result = await axios.get('/api/officio-analysis')

                if (result.data.content.data) {
                    this.dataset.dataList = result.data.content.data
                } else {
                    this.dataset.dataList = {}
                }
           
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { 
                    position: 'top-right', 
                    timeout: 5000 
                })
            }finally {
                this.dataset.loading = false;
            }
        }

    }
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: "Raleway";
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}
</style>
